import React, { useState } from "react";
import { motion, Variants } from "framer-motion";
import HomeServices from "../utilities/HomeServices";
import DoctorMessage from "../utilities/HomeAbout";
import { ValidationError, useForm } from "@formspree/react";
import WhyChooseSection from "../utilities/WhyChooseUs";
import LandingSection from "../utilities/LandingSection";
import TestimonialsSection from "../utilities/TestimonialsSection";
import { HomePageSEO } from '../../SeoTags'


export const containerVariants: Variants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};

export const itemVariants: Variants = {
  hidden: { y: 20, opacity: 0 },
  visible: {
    y: 0,
    opacity: 1,
    transition: {
      type: "spring",
      stiffness: 100
    }
  }
};


const Home: React.FC = () => {
  const [activeLocation, setActiveLocation] = useState<'shalimar' | 'patparganj'>('shalimar');
  const [state, handleSubmit] = useForm("mdkapdnp");
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    appointmentType: 'offline',
    date: '',
    message: '',
  });

  //const ref = React.useRef(null);
  //const isInView = useInView(ref, { once: true, amount: 0.1 });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prevData => ({
      ...prevData,
      [name]: value
    }));
  };

  const handleFinalSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    handleSubmit(formData);
    sendWhatsAppMessage();
  };

  const sendWhatsAppMessage = () => {
    const message = `New Appointment Request:
    Name: ${formData.name}
    Phone: ${formData.phone}
    Email: ${formData.email}
    Appointment : ${formData.appointmentType}
    Date: ${formData.date}
    Message: ${formData.message}`;

    const whatsappNumber = '917827039028';
    const encodedMessage = encodeURIComponent(message);
    const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodedMessage}`;
    window.open(whatsappUrl, '_blank');
  }


  return (
    <>
      <HomePageSEO />
      <LandingSection />
      <DoctorMessage />
      <HomeServices />
      <WhyChooseSection />
      <TestimonialsSection />
      {/* form contact & map */}
      <motion.section
        id="contact-info"
        className="relative min-h-screen flex flex-col md:flex-row items-center justify-center py-16 px-4 md:px-8"
        variants={containerVariants}
      >
        {/* Background Image */}
        <motion.div
          className="absolute inset-0 z-0 shadow-xl"
          style={{
            backgroundImage: "url('/images/contact-home.jpg')",
            backgroundSize: "cover",
            backgroundPosition: "center",
            filter: "brightness(0.7)"
          }}
        />

        {/* Content Container */}
        < motion.div
          className="relative z-10 w-full max-w-7xl mx-auto" variants={containerVariants} >
          <motion.div className="grid grid-cols-1 lg:grid-cols-2 gap-8">


            {/* Google Map Section */}
            <motion.div className="bg-white bg-opacity-90 ring-1 ring-sage/30 rounded-lg shadow-xl overflow-hidden order-2 flex flex-col">
              <div className="flex border-b border-gray-200 bg-gray-50">
                <button
                  type="button"
                  onClick={() => setActiveLocation('shalimar')}
                  className={`flex-1 py-3 px-4 text-center font-semibold text-sm transition-colors ${
                    activeLocation === 'shalimar'
                      ? 'bg-white text-darkbrown border-b-2 border-darkbrown shadow-sm'
                      : 'text-gray-600 hover:text-darkbrown'
                  }`}
                >
                  Max Shalimar Bagh
                  <span className="block text-xs font-normal text-gray-500">Mon-Sat (09:00 AM - 05:00 PM)</span>
                </button>
                <button
                  type="button"
                  onClick={() => setActiveLocation('patparganj')}
                  className={`flex-1 py-3 px-4 text-center font-semibold text-sm transition-colors ${
                    activeLocation === 'patparganj'
                      ? 'bg-white text-darkbrown border-b-2 border-darkbrown shadow-sm'
                      : 'text-gray-600 hover:text-darkbrown'
                  }`}
                >
                  Max Patparganj
                  <span className="block text-xs font-normal text-gray-500">Select Days (09:00 AM - 05:00 PM)</span>
                </button>
              </div>
              <motion.div
                className="w-full h-[70vh] flex-1"
                variants={itemVariants}
              >
                {activeLocation === 'shalimar' ? (
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3498.878939943265!2d77.1554178!3d28.7157833!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d02462e0a2dbb%3A0x6b8bc2ecbf21d4fa!2sMax%20Super%20Speciality%20Hospital%2C%20Shalimar%20Bagh!5e0!3m2!1sen!2sin!4v1710000000000!5m2!1sen!2sin"
                    width="100%"
                    height="100%"
                    style={{ border: 0 }}
                    allowFullScreen={false}
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title="Max Super Speciality Hospital Shalimar Bagh"
                  ></iframe>
                ) : (
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3502.261271183186!2d77.3075841!3d28.6227092!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce354460f4c39%3A0xb3bd3d4342ee8be6!2sMax%20Super%20Speciality%20Hospital%2C%20Patparganj!5e0!3m2!1sen!2sin!4v1710000000000!5m2!1sen!2sin"
                    width="100%"
                    height="100%"
                    style={{ border: 0 }}
                    allowFullScreen={false}
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title="Max Super Speciality Hospital Patparganj"
                  ></iframe>
                )}
              </motion.div>
            </motion.div>

            {/* Form Section */}
            <motion.div className="bg-white/70 bg-opacity-90 ring-1 ring-red-600 rounded-lg shadow-xl overflow-hidden order-1">
              <motion.div
                className="p-8 md:p-12"
                variants={itemVariants}
              >
                <h2 className="text-3xl text-center mb-6 text-charcol font-bold">Book Appointment</h2>
                {state.succeeded ? (
                  <p className="text-indigo-700 font-work-sans">Thank you for your message. We'll get back to you soon!</p>
                ) : (
                  <form onSubmit={handleFinalSubmit} className="space-y-4 font-work-sans">
                    <motion.div variants={itemVariants}>
                      <label htmlFor="name" className="block text-sm font-medium text-charcol">Name</label>
                      <input
                        type="text"
                        id="name"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        placeholder="A Kumar"
                        required
                        className="mt-1 block w-full border border-charcol rounded-md shadow-sm p-2 bg-white text-charcol focus:ring-2 focus:ring-charcol-400 focus:border-transparent"
                      />
                    </motion.div>
                    <motion.div variants={itemVariants}>
                      <label htmlFor="email" className="block text-sm font-medium text-charcol">Email</label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                        placeholder="youremail@domain.com"
                        className="mt-1 block w-full border border-charcol rounded-md shadow-sm p-2 bg-white text-charcol focus:ring-2 focus:ring-charcol-400 focus:border-transparent"
                      />
                      <ValidationError prefix="Email" field="email" errors={state.errors} />
                    </motion.div>
                    <div>
                      <label className="block text-sm font-medium text-charcol mb-2">Appointment Type</label>
                      <div className="flex flex-wrap gap-4">
                        <label className="inline-flex items-center">
                          <input
                            type="radio"
                            name="appointmentType"
                            value="offline"
                            checked={formData.appointmentType === 'offline'}
                            onChange={handleChange}
                            className="form-radio text-charcol focus:ring-charcol h-4 w-4"
                          />
                          <span className="ml-2 text-charcol">Offline Appointment</span>
                        </label>
                        <label className="inline-flex items-center">
                          <input
                            type="radio"
                            name="appointmentType"
                            value="online"
                            checked={formData.appointmentType === 'online'}
                            onChange={handleChange}
                            className="form-radio text-charcol focus:ring-charcol h-4 w-4"
                          />
                          <span className="ml-2 text-charcol">Online Appointment</span>
                        </label>
                      </div>
                    </div>
                    <motion.div variants={itemVariants}>
                      <label htmlFor="phone" className="block text-sm font-medium text-charcol">Phone</label>
                      <input
                        type="tel"
                        id="phone"
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                        required
                        placeholder="XXX-XXXX"
                        className="mt-1 block w-full border border-charcol rounded-md shadow-sm p-2 bg-white text-charcol focus:ring-2 focus:ring-charcol focus:border-transparent"
                      />
                    </motion.div>
                    <motion.div variants={itemVariants}>
                      <label htmlFor="date" className="block text-sm font-medium text-charcol">Date</label>
                      <input
                        type="date"
                        id="date"
                        name="date"
                        value={formData.date}
                        onChange={handleChange}
                        required
                        placeholder="Select Date"
                        className="mt-1 block w-full border border-charcol rounded-md shadow-sm p-2 bg-white text-charcol focus:ring-2 focus:ring-charcol focus:border-transparent"
                      />
                      <ValidationError prefix="Date" field="date" errors={state.errors} />
                    </motion.div>
                    <motion.div variants={itemVariants}>
                      <label htmlFor="message" className="block text-sm font-medium text-charcol">Message</label>
                      <textarea
                        id="message"
                        name="message"
                        value={formData.message}
                        onChange={handleChange}
                        rows={4}
                        required
                        className="mt-1 block w-full border border-charcol rounded-md shadow-sm p-2 bg-white text-charcol focus:ring-2 focus:ring-charcol focus:border-transparent"
                      ></textarea>
                    </motion.div>
                    <motion.div variants={itemVariants}>
                      <button
                        type="submit"
                        disabled={state.submitting}
                        className="w-full px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-charcol hover:bg-yellow-600 transition-colors duration-300"
                      >
                        Send Message
                      </button>
                    </motion.div>
                  </form>
                )}
              </motion.div>
            </motion.div>
          </motion.div>
        </motion.div >
      </motion.section >

    </>

  );
};

export default Home;